"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTokenValidator = void 0;
const aws_jwt_verify_1 = require("aws-jwt-verify");
const isValidCognitoToken_1 = require("./isValidCognitoToken");
/**
 * Creates a validator object for validating methods in a KeyValueStorage.
 */
const createTokenValidator = ({ userPoolId, userPoolClientId: clientId, }) => {
    let idTokenVerifier;
    let accessTokenVerifier;
    return {
        // validate access, id tokens
        getItem: async (key, value) => {
            const isAccessToken = key.includes('.accessToken');
            const isIdToken = key.includes('.idToken');
            if (!isAccessToken && !isIdToken) {
                return true;
            }
            if (!userPoolId || !clientId) {
                return false;
            }
            if (isAccessToken && !accessTokenVerifier) {
                accessTokenVerifier = aws_jwt_verify_1.CognitoJwtVerifier.create({
                    userPoolId,
                    tokenUse: 'access',
                    clientId,
                });
            }
            if (isIdToken && !idTokenVerifier) {
                idTokenVerifier = aws_jwt_verify_1.CognitoJwtVerifier.create({
                    userPoolId,
                    tokenUse: 'id',
                    clientId,
                });
            }
            return (0, isValidCognitoToken_1.isValidCognitoToken)({
                token: value,
                verifier: isAccessToken ? accessTokenVerifier : idTokenVerifier,
            });
        },
    };
};
exports.createTokenValidator = createTokenValidator;
